import React, { useState } from 'react';
import logo from './logo.svg';
import './App.css';

const apps = [
  {
    name: 'Deckhand',
    description: 'Clash Royale deck builder. Build, compare, and discover winning decks.',
    icon: 'blue-king.webp',
    url: 'https://deckhand.web.app',
  },
];

function App() {
  const [showApps, setShowApps] = useState(false);

  if (showApps) {
    return (
      <div className="App">
        <div className="Apps-page">
          <button className="Apps-back" onClick={() => setShowApps(false)}>
            &larr; Back
          </button>
          <h1 className="Apps-title">Inbik Apps</h1>
          <div className="Apps-container">
            {apps.map((app) => (
              <a
                key={app.name}
                href={app.url}
                className="App-card"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="App-card-icon">
                  <img src={app.icon} alt={app.name} className="App-card-icon-img" />
                </div>
                <h2>{app.name}</h2>
                <p>{app.description}</p>
              </a>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <header className="App-header">
        <img
          src={logo}
          className="App-logo App-logo-clickable"
          alt="logo"
          onClick={() => setShowApps(true)}
        />
        <p>
          Welcome to Inbik!
        </p>
      </header>
    </div>
  );
}

export default App;
